import React from "react";
import { useState } from "owa-react";
import { observer } from "owa-mobx-react";

type StatusBarViewState = {
    isNormalView: boolean;
    onViewChanged: (isNormalView: boolean) => void;
};

type StatusBarViewShortcutsContextValue = {
    viewState: StatusBarViewState | undefined;
    updateViewState: (viewState: StatusBarViewState | undefined) => void;
};

export const StatusBarViewShortcutsContext = React.createContext<StatusBarViewShortcutsContextValue>({
    viewState: undefined,
    updateViewState: () => undefined,
});

export const StatusBarViewShortcutsContextProvider: React.FunctionComponent<React.PropsWithChildren> = observer(function StatusBarViewShortcutsContextProvider({ children }) {
    const [isNormalView, setIsNormalView] = useState<boolean>();
    const onViewChangedRef = React.useRef<StatusBarViewState["onViewChanged"]>();
    const onViewChanged = React.useCallback((nextIsNormalView: boolean) => {
        onViewChangedRef.current?.(nextIsNormalView);
    }, []);
    const updateViewState = React.useCallback((nextViewState: StatusBarViewState | undefined) => {
        onViewChangedRef.current = nextViewState?.onViewChanged;
        setIsNormalView(nextViewState?.isNormalView);
    }, []);
    const viewState = React.useMemo(() => (isNormalView === undefined ? undefined : { isNormalView, onViewChanged }), [isNormalView, onViewChanged]);
    const value = React.useMemo(() => ({ viewState, updateViewState }), [viewState, updateViewState]);
    
    return (<StatusBarViewShortcutsContext.Provider value={value}>
                {children}
            </StatusBarViewShortcutsContext.Provider>);
}, "StatusBarViewShortcutsContextProvider");

export function useStatusBarViewShortcutsContext(): StatusBarViewShortcutsContextValue {
    return React.useContext(StatusBarViewShortcutsContext);
}
